// @ts-expect-error not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
const CallDetailsPropType = RecordPropType('CallMessage');
export default CallDetailsPropType;